import React, { useContext, useEffect } from "react";

import AuthContext from "./auth-context";
import { useNavigate } from "react-router-dom";
import TimeOutPopUp from "./TimeOutPopUp";
import SessionContext from "./SessionContext";

const TimeoutComponent = () => {
  let navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const { isActive, setIsActive } = useContext(SessionContext);
  const timeoutDuration = 30 * 60 * 1000;

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsActive(false);
      }, timeoutDuration);
    };

    const clearTimer = () => {
      clearTimeout(timeout);
    };

    const handleUserActivity = () => {
      resetTimer();
    };

    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);

    resetTimer();

    return () => {
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
      clearTimer();
    };
  }, []);

  useEffect(() => {
    if (!isActive) {
      authCtx.logout();
      sessionStorage.clear();
      localStorage.clear();
      navigate("/login");
    }
  }, [isActive]);

  if (!isActive) {
    // handleLogout()
    return (
      <>
        <TimeOutPopUp />
      </>
    );
  }
};

export default TimeoutComponent;
